<template>
    <div class="pa-5 pt-0" v-if="activeProduct">
        <v-divider class="mb-3" />
        <div>
            <strong>{{ "Other" | t }}:</strong>
        </div>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Has product label" | t }}</v-col>
            <v-col cols="6">
                <v-checkbox
                    hide-details
                    class="mt-0 mb-0"
                    @change="updateField($event, 'has_product_label')"
                    v-model="activeProduct.has_product_label"
                    :value="activeProduct.has_product_label"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Store from "../../../store";

export default {
    name: "package-other-edit-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    },
    methods: {
        updateField(value, field) {
            Store.commit("ProductStore/updateActiveProductProperty", { prop: field, value: !!value });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
